module.exports = __webpack_public_path__ + "img/icon_guides_and_videos.78a57db5.svg";